// eslint-disable-next-line no-use-before-define
import React, { FunctionComponent, useEffect } from "react";
import Multiselect from "multiselect-react-dropdown";
import {
  MultiSelectFieldProps,
  SelectOptions,
} from "../../../interfaces/components/form.interface";

const InputMultiSelectComponent: FunctionComponent<MultiSelectFieldProps> = ({
  label,
  bold,
  id,
  options,
  isSingleSelect,
  disabled,
  placeholder,
  onMultiSelectChangeHandler,
  onSelectChangeHandler,
  value,
  required,
}: MultiSelectFieldProps) => {
  const [_value, setValue] = React.useState(value);

  // function that chacks if two arrays are equal and the data inside them

  useEffect(() => {
    // check if value is an array then set the values to the state
    //  const isValueExist = options.find((r) => r.id === value?.id);
    //   if (isValueExist) setValue(isValueExist);
  }, [value, options]);

  const onSelect = (
    selectedList: Array<SelectOptions>,
    selectedItem: SelectOptions
  ): void => {
    if (isSingleSelect && onSelectChangeHandler) {
      onSelectChangeHandler(selectedItem);
    } else if (!isSingleSelect && onMultiSelectChangeHandler) {
      onMultiSelectChangeHandler(selectedList);
    }
  };

  const onRemove = (
    selectedList: Array<SelectOptions>,
    removedItem: SelectOptions
  ): void => {
    if (isSingleSelect && onSelectChangeHandler) {
      onSelectChangeHandler(removedItem);
    } else if (!isSingleSelect && onMultiSelectChangeHandler) {
      onMultiSelectChangeHandler(selectedList);
    }
  };

  return (
    <div className="selectInput__wrapper" data-test="inputMultiSelect-wrapper">
      {label && bold && (
        <label
          className="textInput__label"
          htmlFor={id}
          data-test="inputMultiSelect-label"
        >
          <b>{label}</b>
        </label>
      )}
      {label && !bold && (
        <label
          className="multiSelectInput__label"
          htmlFor={id}
          data-test="inputMultiSelect-label"
        >
          {label}
        </label>
      )}
      {!disabled && (
        <Multiselect
          options={options} // Options to display in the dropdown
          selectedValues={value} // Preselected value to persist in dropdown
          onSelect={onSelect} // Function will trigger on select event
          onRemove={onRemove} // Function will trigger on remove event
          singleSelect={isSingleSelect} // Single selection
          placeholder={placeholder}
          data-test="inputMultiSelect-select"
          displayValue="value"
          disable={disabled}
          id={id}
        />
      )}

      {disabled && Array.isArray(value) && (
        <div className="textInput__input textInput__input--disabled">
          {value.map((item) => (
            <span key={item.id}>
              {options.find((r) => r.id === item.id)?.value}
              <br />
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
export default InputMultiSelectComponent;
